import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export default function About() {
  return (
    <Layout>


      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/80 text-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            About Us
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            Discover our journey of excellence in mineral production and supply
          </p>
        </div>
      </section>
      {/* Our Company Section */}
      <section className="py-16 bg-gradient-to-b from-white via-muted/30 to-white w-full">
        <div className="w-full px-6 md:px-12 lg:px-20">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-4xl font-extrabold text-primary mb-6 inline-block relative after:content-[''] after:block after:w-20 after:h-1 after:bg-accent after:mx-auto after:mt-3 after:rounded-full drop-shadow-sm">
              Our Company
            </h2>

            <p className="text-lg text-foreground/80 mb-4 leading-relaxed max-w-4xl mx-auto">
              Founded in <span className="font-semibold text-blue-700">2010</span>, we began with a single production plant and a bold vision - to deliver reliable, high-quality foundational materials to industries worldwide. Recognizing the growing global demand for dependable resources, we rapidly expanded and now proudly operate <span className="font-semibold text-blue-700">15 production houses</span> serving clients across international markets.
            </p>

            <p className="text-lg text-foreground/80 mb-4 leading-relaxed max-w-4xl mx-auto">
              Our journey is powered by <span className="font-semibold text-blue-700">innovation, integrity, and operational excellence</span>. Backed by a team of <span className="font-semibold text-blue-700">300 dedicated professionals</span>, we ensure every product meets the stringent quality standards of the world market.
            </p>

            <p className="text-lg text-foreground/80 mb-8 leading-relaxed max-w-4xl mx-auto">
              Our raw materials form the backbone of a wide range of industries - from <span className="font-semibold text-blue-700">ceramics, paint, and plastics</span> to <span className="font-semibold text-blue-700">leather and beyond</span>. Through consistent quality and dependable partnerships, we have become a <span className="font-semibold text-blue-700">trusted global supplier</span>, bridging supply chain gaps and empowering businesses to achieve greater success.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-8 border-t border-b border-border">
              <div className="text-center transform transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-extrabold text-accent mb-2 drop-shadow">
                  15+
                </div>
                <p className="text-foreground/70 text-lg">Years of Experience</p>
              </div>

              <div className="text-center transform transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-extrabold text-accent mb-2 drop-shadow">
                  25000+
                </div>
                <p className="text-foreground/70 text-lg">MT Production Monthly</p>
              </div>

              <div className="text-center transform transition-all duration-300 hover:scale-105">
                <div className="text-5xl font-extrabold text-accent mb-2 drop-shadow">
                  500+
                </div>
                <p className="text-foreground/70 text-lg">Happy Customers</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Vision & Mission Section */}
      <section className="py-10 bg-muted/10 w-full">
        <div className="w-full px-6 md:px-12 lg:px-20">
          <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-6">
            <div className="hover:shadow-lg p-8 rounded-2xl bg-white transition-all duration-300 border border-border hover:-translate-y-1">
              <h3 className="text-2xl font-bold text-primary mb-3 relative inline-block after:content-[''] after:block after:w-16 after:h-1 after:bg-accent after:mt-2 after:rounded-full">
                Our Vision
              </h3>
              <p className="text-foreground/80 leading-relaxed">
                To become the most trusted and innovative mineral supplier worldwide -
                driven by quality, sustainability, and technological excellence.
              </p>
            </div>

            <div className="hover:shadow-lg p-8 rounded-2xl bg-white transition-all duration-300 border border-border hover:-translate-y-1">
              <h3 className="text-2xl font-bold text-primary mb-3 relative inline-block after:content-[''] after:block after:w-16 after:h-1 after:bg-accent after:mt-2 after:rounded-full">
                Our Mission
              </h3>
              <p className="text-foreground/80 leading-relaxed">
                We strive to deliver premium-grade minerals with consistent quality,
                unmatched service, and timely delivery - ensuring maximum client satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Infrastructure & Quality Section */}
      <section className="py-10 bg-gradient-to-br from-muted/5 to-accent/5 w-full">
        <div className="w-full px-6 md:px-12 lg:px-20">
          <div className="max-w-7xl mx-auto">
            <div className="p-10 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 border border-border hover:-translate-y-1">
              <h3 className="text-2xl font-semibold text-primary mb-4 relative inline-block after:content-[''] after:block after:w-20 after:h-1 after:bg-accent after:mt-2 after:rounded-full">
                Infrastructure & Quality
              </h3>
              <p className="text-foreground/80 mb-4 leading-relaxed">
              Our robust infrastructure is supported by dedicated mining operations at strategic locations. We own and operate Potash Mines at Dantda Rajsamand and Soda Mines in Udaipur, both renowned for their superior quality mineral deposits. These prime mining locations enable us to source high-grade raw materials directly from the origin, ensuring consistent supply and uncompromised product quality. Combined with our advanced processing units, in-house laboratories, and extensive distribution network, this integrated setup allows us to maintain excellence from extraction to delivery.

              </p>
             
            </div>
          </div>
        </div>
      </section>



    </Layout>
  );
}
